import clsx from 'clsx'
import React, { CSSProperties, FC, PropsWithChildren } from 'react'

import styles from './Container.module.scss'

interface ContainerProps {
  className?: string
  id?: string
  noPaddingPhablet?: boolean
  style?: CSSProperties
  width?: 'small' | 'medium' | 'wide'
}

/**
 * @deprecated Your container is in another castle! specify you components constrains more locally.
 */
const Container: FC<PropsWithChildren<ContainerProps>> = ({ children, className, id, noPaddingPhablet, style, width }) => (
  <div
    className={clsx(className, styles.container, noPaddingPhablet && styles.noPaddingOnPhablet, width && styles[width])}
    id={id}
    style={style}
  >
    {children}
  </div>
)

export default Container
